module.exports = __webpack_public_path__ + "img/australia-digestive-diseases-female.49c6fe1a.png";